import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Checkbox, Divider, getTestId, LILAC_400, Radio, Typography, useBreakpoint, WHITE } from '@airtel/air-design-system';
import { useEffect, useState } from 'react';
import { Pressable, ScrollView, StyleSheet, View } from 'react-native';
import { getFilterDropdownStyles } from './DropdownFilterStyles';
export var DropdownFilter = props => {
  var title = props.title,
    _props$quickFilterLis = props.quickFilterList,
    quickFilterList = _props$quickFilterLis === void 0 ? [] : _props$quickFilterLis,
    _props$quickFilterTit = props.quickFilterTitle,
    quickFilterTitle = _props$quickFilterTit === void 0 ? 'Filter' : _props$quickFilterTit,
    onQuickFilterChange = props.onQuickFilterChange,
    _props$isRadioBoxFilt = props.isRadioBoxFilter,
    isRadioBoxFilter = _props$isRadioBoxFilt === void 0 ? false : _props$isRadioBoxFilt,
    style = props.style,
    setShowDropdown = props.setShowDropdown,
    showDropdown = props.showDropdown,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'DropdownFilter' : _props$testID,
    setIsFilterEnable = props.setIsFilterEnable;
  var filterStyle = getFilterDropdownStyles();
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var _useState = useState(quickFilterList),
    checkedState = _useState[0],
    setCheckedState = _useState[1];
  var _useState2 = useState(true),
    selectAll = _useState2[0],
    setSelectAll = _useState2[1];
  var _useState3 = useState(false),
    isBtnDisable = _useState3[0],
    setIsBtnDisable = _useState3[1];
  useEffect(() => {
    setCheckedState(quickFilterList);
  }, [JSON.stringify(quickFilterList)]);
  var handleQuickFilterChange = position => {
    var updatedCheckedState = checkedState === null || checkedState === void 0 ? void 0 : checkedState.map((item, i) => {
      item.checked = i === position ? !item.checked : item.checked;
      return item;
    });
    setCheckedState(updatedCheckedState);
    var filterCheckedItems = checkedState === null || checkedState === void 0 ? void 0 : checkedState.filter(item => (item === null || item === void 0 ? void 0 : item.checked) == true);
    var isAllChecked = (filterCheckedItems === null || filterCheckedItems === void 0 ? void 0 : filterCheckedItems.length) === (quickFilterList === null || quickFilterList === void 0 ? void 0 : quickFilterList.length);
    setSelectAll(isAllChecked);
    filterCheckedItems.length === 0 ? setIsBtnDisable(true) : setIsBtnDisable(false);
  };
  var handleQuickFilterChangeRadio = position => {
    var updatedCheckedState = checkedState === null || checkedState === void 0 ? void 0 : checkedState.map((item, i) => {
      if (i === position) {
        item.checked = !(item === null || item === void 0 ? void 0 : item.checked);
      } else {
        item.checked = false;
      }
      return item;
    });
    setCheckedState(updatedCheckedState);
    var filterCheckedItems = checkedState === null || checkedState === void 0 ? void 0 : checkedState.filter(item => (item === null || item === void 0 ? void 0 : item.checked) == true);
    var isAllChecked = (filterCheckedItems === null || filterCheckedItems === void 0 ? void 0 : filterCheckedItems.length) === (quickFilterList === null || quickFilterList === void 0 ? void 0 : quickFilterList.length);
    setSelectAll(isAllChecked);
    filterCheckedItems.length === 0 ? setIsBtnDisable(true) : setIsBtnDisable(false);
  };
  var clearAllHandler = () => {
    setCheckedState(prevState => {
      return prevState.map(item => {
        item.checked = false;
        return item;
      });
    });
    setSelectAll(false);
    setIsBtnDisable(true);
  };
  var selectAllHandler = () => {
    setCheckedState(prevState => {
      return prevState.map(item => {
        item.checked = !selectAll;
        return item;
      });
    });
    setSelectAll(!selectAll);
    setIsBtnDisable(!selectAll ? false : true);
  };
  var applyHandler = () => {
    setShowDropdown(false);
    onQuickFilterChange === null || onQuickFilterChange === void 0 ? void 0 : onQuickFilterChange({
      filterList: checkedState
    });
    !isRadioBoxFilter && setIsFilterEnable(selectAll ? false : true);
  };
  return _jsxs(View, Object.assign({
    style: [filterStyle.headerContainer, showDropdown && {
      zIndex: 9
    }, style]
  }, getTestId(testID), {
    children: [title && _jsx(Typography, Object.assign({
      style: filterStyle.headerText,
      text: title,
      type: "body-para-md-bold",
      numberOfLines: 2
    }, getTestId(testID, 'title'))), showDropdown && _jsxs(View, Object.assign({
      style: filterStyle.dropdownContainer
    }, {
      children: [_jsx(Pressable, {
        style: [StyleSheet.absoluteFill, filterStyle.backdrop],
        onPress: () => setShowDropdown(false)
      }), _jsxs(View, Object.assign({
        style: filterStyle.dropdown
      }, {
        children: [quickFilterTitle && _jsxs(View, Object.assign({
          style: filterStyle.dropdownItem
        }, {
          children: [_jsx(Typography, {
            text: quickFilterTitle,
            type: "title-single-line-xl"
          }), _jsx(Button, {
            title: "Clear all",
            buttonType: "tertiary",
            size: "md",
            style: filterStyle.clearBtn,
            onPress: clearAllHandler
          })]
        })), !isRadioBoxFilter && _jsx(View, Object.assign({
          style: filterStyle.dropdownItem
        }, {
          children: _jsx(Checkbox, Object.assign({
            label: "Select all",
            isBoldLabel: true,
            size: "sm",
            checked: selectAll,
            onPress: selectAllHandler
          }, getTestId(testID, 'checkbox')))
        })), _jsx(Divider, {
          height: 2,
          color: LILAC_400,
          shadowColor: WHITE
        }), !isRadioBoxFilter && _jsx(ScrollView, Object.assign({
          keyboardShouldPersistTaps: "handled"
        }, {
          children: (checkedState === null || checkedState === void 0 ? void 0 : checkedState.length) > 0 && (checkedState === null || checkedState === void 0 ? void 0 : checkedState.map((data, index) => {
            return _jsx(View, Object.assign({
              style: filterStyle.dropdownItem
            }, {
              children: _jsx(Checkbox, Object.assign({
                label: data.label,
                isBoldLabel: true,
                size: "sm",
                checked: data.checked,
                onPress: () => handleQuickFilterChange(index)
              }, getTestId(testID, 'checkbox')))
            }), "single_item_" + index);
          }))
        })), isRadioBoxFilter && _jsx(ScrollView, Object.assign({
          keyboardShouldPersistTaps: "handled"
        }, {
          children: checkedState.length > 0 && (checkedState === null || checkedState === void 0 ? void 0 : checkedState.map((data, index) => {
            return _jsxs(View, Object.assign({
              style: filterStyle.dropdownItem
            }, {
              children: [(data === null || data === void 0 ? void 0 : data.stringType) && _jsx(View, {
                children: _jsx(Typography, {
                  type: isLargeScreen ? 'title-para-md' : 'title-para-sm',
                  text: data === null || data === void 0 ? void 0 : data.label
                })
              }), !(data === null || data === void 0 ? void 0 : data.stringType) && _jsx(Radio, Object.assign({
                label: data.label,
                isBoldLabel: true,
                size: "sm",
                checked: data.checked,
                onPress: () => handleQuickFilterChangeRadio(index)
              }, getTestId(testID, 'radio')))]
            }), "single_item_" + index);
          }))
        })), _jsx(Divider, {
          height: 2,
          color: LILAC_400,
          shadowColor: WHITE
        }), _jsx(View, Object.assign({
          style: filterStyle.button
        }, {
          children: _jsx(Button, {
            title: "Apply",
            size: "sm",
            version: "variable-width",
            onPress: applyHandler,
            disabled: isBtnDisable ? true : false
          })
        }))]
      }))]
    }))]
  }));
};